export default __webpack_public_path__ + "static/media/fWINGS.02bea6d2.svg";